import { Button } from 'antd';
import { shade } from 'polished';
import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px 0;
`;
export const Text = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
`;
export const Title = styled(Text)`
  margin-top: 24px;
  font-size: 24px;
  color: black;
`;
export const SubTitle = styled(Text)`
  font-size: 14px;
  color: #98a9bc;
  text-align: center;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0 40px;
  margin-bottom: 24px;
  width: 100%;
`;
export const Create = styled(Button)`
  background: #ffba00;
  color: #ffffff;
  &:hover {
    background-color: ${shade(0.2, '#ffba00')};
    color: #ffffff;
  }
`;
export const Cancel = styled(Button)`
  border: 0;
`;